import Text from '@zenbusiness/common-components/Text';
import { NavLink } from 'react-router-dom';

import { styled } from '@mui/material/styles';

export const Link = styled(NavLink)(({ theme }) => ({
  display: 'flex',
  gap: '0.75rem',
  padding: '0.75rem 1.5rem',
  fontSize: '1rem',
  lineHeight: '1.5',
  width: '100%',

  [theme.breakpoints.up('sm')]: {
    fontSize: '1.125rem'
  },

  [theme.breakpoints.up('md')]: {
    fontSize: '1.25rem',
    lineHeight: '1.75rem'
  },

  [theme.breakpoints.up('lg')]: {
    fontSize: '1.375rem',
    paddingBlock: '1.125rem'
  }
}));

export const Pill = styled(Text)(({ theme }) => ({
  backgroundColor: theme.palette.creativity10.main,
  padding: '2px 6px',
  borderRadius: 18,
  textTransform: 'uppercase'
}));

export const TruncatedText = styled('span')(() => ({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
}));
